import { useEffect } from "react";
import { useSyncExternalStore } from "react";

// Le minuteur de la partie vit dans la barre de navigation, au centre : c'est le
// même repère pour tous les modes. Les écrans de jeu, eux, restent maîtres de
// leur décompte — ils le publient ici, la barre s'y abonne.
let current = null;
const subs = new Set();

function emit(next) {
  current = next;
  subs.forEach(fn => fn());
}
function subscribe(fn) { subs.add(fn); return () => subs.delete(fn); }
function snapshot() { return current; }

// `timer` : { remaining, duration, idle } — `idle` pour les temps morts
// (révélation, pause), où le rond affiche un point au lieu d'un décompte.
export function useGameTimer(timer) {
  const remaining = timer?.remaining ?? null;
  const duration = timer?.duration ?? null;
  const idle = !!timer?.idle;
  useEffect(() => {
    emit(remaining === null && !idle ? null : { remaining, duration, idle });
  }, [remaining, duration, idle]);
  // Quitter l'écran de jeu éteint le minuteur
  useEffect(() => () => emit(null), []);
}

export function useNavTimer() {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
